import { STORE_IMMUTABLE_FILTER_LIST } from "../actions";

export default function filter(state = [], action) {
  switch (action.type) {
    case STORE_IMMUTABLE_FILTER_LIST:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/immutableFilterList.js